module.exports = __webpack_public_path__ + "static/media/Dead.1dc7e9d8.mp3";